import React, {Component} from 'react';
import Navigation from './head-and-foot/Navigation';
import PageTitle from './head-and-foot/PageTitle';
import Footer from './head-and-foot/Footer';
import Main from './main-content/Main'


export default class App extends Component {
    render() {
        return (
            <div>
                <Navigation />

                <PageTitle/>

                <Main/>

                <hr />

                <Footer/>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/App.js